import { SetURLSearchParams } from 'src/hooks/useSearchParams';
import { SearchParams } from 'src/types/searchParams.enum';
import StorageService from 'src/services/storage.service';
import { SPENDSMART_LANDING_PAGE_URL } from 'src/config';

export const isMobileApp = (): boolean => {
    return StorageService.getNative();
};

export const appendNativeParam = (searchParams: URLSearchParams, setSearchParams: SetURLSearchParams): void => {
    if (StorageService.getNative() && searchParams.get(SearchParams.NATIVE) !== 'true') {
        searchParams.set(SearchParams.NATIVE, 'true');
        setSearchParams(searchParams);
    } else if (!StorageService.getNative() && searchParams.get(SearchParams.NATIVE) === 'true') {
        StorageService.setNative();
    }
};

export const getSpendsmartLandingPageUrl = (redirect: boolean = true): string => {
    return `${SPENDSMART_LANDING_PAGE_URL}${isMobileApp() ? `?${SearchParams.NATIVE}=true` : ''}${
        redirect ? '' : '?redirect=false'
    }`;
};
